import React from 'react';
import DualAxisChart from '../charts/DualAxisChart'
import parse from 'date-fns/parse'

const ChartContainer = ({data}) => {
  const dataToPoint = accessor => elt => ([
    parse(`${elt.date} +00`, 'yyyy-MM-dd x', new Date()).getTime(),
    elt[accessor]
  ])

  const dataToPointRate = (numerator, divider) => elt => ([
    parse(`${elt.date} +00`, 'yyyy-MM-dd x', new Date()).getTime(),
    100 * elt[numerator]/elt[divider]
  ])

  const dataToChartSeries = (data) => {
    const active_devices = data.map(dataToPoint("active_devices"))
    const location_authorized_devices = data.map(dataToPoint("location_authorized_devices"))
    const loc_consented_devices = data.map(dataToPoint("loc_consented_devices"))
    const optin_geoloc = data.map(dataToPointRate("location_authorized_devices", "active_devices"))
    const consented_devices = data.map(dataToPointRate("consented_devices", "active_devices"))
    const optin_global = data.map(dataToPointRate("loc_consented_devices", "active_devices"))
    return [
      {
        "name": "Devices actifs",
        "data": active_devices,
        "color": "#B2382B",
        "visible": false,
        "type": "areaspline"
      },
      {
        "name": "Devices géolocalisés",
        "data": location_authorized_devices,
        "color": "#FED3CF",
        "visible": false,
        "type": "areaspline"
      },
      {
        "name": "Devices géolocalisés consentis",
        "data": loc_consented_devices,
        "color": "#FF513C",
        "visible": true,
        "type": "areaspline"
      },
      {
        "name": "Opt-in géoloc",
        "data": optin_geoloc,
        "color": "#0d233a",
        "yAxis": 1,
        "type": "spline",
        "visible": false,
        "tooltip": {
          "valueDecimals": 2,
          "valueSuffix": "%"
        }
      },
      {
        "name": "Consentement",
        "data": consented_devices,
        "color": "#DDDDDD",
        "yAxis": 1,
        "type": "spline",
        "visible": false,
        "tooltip": {
          "valueDecimals": 2,
          "valueSuffix": "%"
        }
      },
      {
        "name": "Opt-in global",
        "data": optin_global,
        "color": "#888888",
        "yAxis": 1,
        "type": "spline",
        "visible": true,
        "tooltip": {
          "valueDecimals": 2,
          "valueSuffix": "%"
        }
      }
    ]
  }
  const chartData = dataToChartSeries(data);
  return (<DualAxisChart legendOptions={{clickable: true}} series={chartData}/>)
}

export default ChartContainer